// extracted by mini-css-extract-plugin
module.exports = {"container":"_36e3m","isTop":"_24lHe","pagination":"_33Kbo","arrow":"_2otqk","page":"_3tTZn","active":"_1Lv9D"};